
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, watchEffect, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10Api'
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      total: 0,
      current: 1,
      size: 10,
      pagination: {},
      spinning: true
    })
    pageData.total = computed(() => {
      return ((props.pageSourceData || {}).ResearchReport || {}).Total
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: number) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: false,
        onChange: changeSize,
        onShowSizeChange: changeSize
      }
    })
    pageData.columns = [
      {
        title: '撰写日期',
        dataIndex: 'date',
        key: 'date',
        width: '100px'
      },
      {
        title: '研报标题',
        dataIndex: 'Title',
        key: 'Title',
        ellipsis: true,
        slots: { customRender: 'link', type: 'link' }
        // slots: { customRender: "title" }
      },
      {
        title: '评级',
        dataIndex: 'RatingOrg',
        key: 'RatingOrg',
        width: '140px'
      },
      {
        title: '作者',
        dataIndex: 'Author',
        key: 'Author',
        ellipsis: true,
        // slots: { customRender: "name" },
        width: '100px'
      }
    ]
    watch(
      () => ((props.pageSourceData || {}).ResearchReport || {}).ResearchReportData,
      () => {
        const data = ((props.pageSourceData || {}).ResearchReport || {}).ResearchReportData
        pageData.data = handlerData(data)
        nextTick(() => {
          pageData.spinning = false
        })
      }
    )
    const route = useRoute()
    function getDetail(PageIndex: number, PageSize: number) {
      const data: any = {}
      data.data = {
        Insts: [
          {
            Exch: route.query.market,
            Inst: route.query.code
          }
        ],
        RatingFilter: 0,
        PageIndex: PageIndex,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getReportDetail(data).then((res: any) => {
        const arr = (res.Data || {}).ReportListData
        pageData.data = handlerData(arr)
        pageData.total = res.total
      })
    }
    function changeSize(current: number, size: number) {
      nextTick(() => {
        const wrapper: any = document.querySelector('.wrapper')
        const target: any = document.getElementById('yjbg')
        wrapper.scrollTop = target.offsetTop
      })
    }
    function handlerData(arr: any) {
      if ((arr || []).length < 1) return []
      arr.forEach((item: any, i: number) => {
        item.index = 'yjbg' + i
        item.date = window.moment(item.PublishDate).format('YYYY-MM-DD')
      })
      return arr
    }
    return {
      ...toRefs(pageData)
    }
  }
})
